export default __webpack_public_path__ + "static/media/bg5.f4ba1bc4.png";